import { Layout, Snackbar } from "@mcleod/components";
import { Currency } from "@mcleod/core";

export class PayAdjustmentUtil {
    static isEarning(type: string): boolean {
        return type == "E" || type == "R";
    }

    static isDeduction(type: string): boolean {
        return type == "D" || type == "B";
    }

    static validDeductCodeChange(oldType: string, newType: string, glAccrualAmount: Currency, currentLayout: Layout): boolean {
        if (glAccrualAmount != null && !glAccrualAmount.isZero()) {
            if (this.isEarning(oldType) && this.isDeduction(newType)) {
                Snackbar.showWarningSnackbar("Accrued pay adjustment can not be changed from a "
                    + "reimbursement / earning to a deduction. Please void this entry and re-add to correct.", { targetPanel: currentLayout });
                return false;
            }
            if (this.isEarning(newType) && this.isDeduction(oldType)) {
                Snackbar.showWarningSnackbar("Accrued pay adjustment can not be changed from a "
                    + "deduction to a reimbursement / earning. Please void this entry and re-add to correct.", { targetPanel: currentLayout });
                return false;
            }
        }
        return true;


    }
}
